import { CURRENCY_CODE } from "@/lib/constant";
import { sendGTMEvent } from "@next/third-parties/google";
import { formatItems } from "@repo/lib/helpers";
import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useAddPaymentInfoEvent = () => {
  const isGTMEnabled = useFeatureFlag("gtm");
  const handleAddPaymentInfoEvent = useCallback(
    (cart, selectedPaymentMethod) => {
      if (!isGTMEnabled) {
        return;
      }
      const { cartTotal, lineItems, couponName } = cart;
      sendGTMEvent({
        event: "add_payment_info",
        currency: CURRENCY_CODE,
        value: cartTotal?.total,
        coupon: couponName || "",
        payment_type: selectedPaymentMethod,
        items: formatItems(lineItems, couponName),
      });
    },
    [isGTMEnabled]
  );

  return { handleAddPaymentInfoEvent };
};

export default useAddPaymentInfoEvent;
